import React from 'react';
import PDFViewer from './PDFViewer';
import styled from 'styled-components';
import { createPortal } from "react-dom";
import CloseCircle from "../icons/CloseCircle";

export default ({onPdfLoad = () => {}, ...props}) => (
  createPortal(
    <Modal>
      <CloseButton onClick={props.onCloseButtonClick}>
        <CloseCircle />
      </CloseButton>

      <ModalInner>
        <PDFViewer
          fileName={props.asset.name}
          url={`https://valentino-cdn.thron.com/delivery/public/document/valentino/${props.asset.contentId}/${props.asset.pKey}/WEB/${props.asset.name}`}
          isMobile={props.isMobile}
          onLoad={onPdfLoad}
        />
      </ModalInner>
    </Modal>,
    window.document.body,
  )
)

const Modal = styled.div`
  z-index: 209; // ModalFullScreen is 109
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: calc(max(.5rem, env(safe-area-inset-top)) - .5rem);
  background-color: rgb(0 0 0 / .7);
  cursor: pointer;
`;

const ModalInner = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;


const CloseButton = styled.button`
  z-index: 1;
  align-self: flex-end;
  cursor: pointer;
  padding: .5rem .5rem .5rem;
  border: none;
  background-color: transparent;

  svg {
    width: 2rem;
    color: #fff;
  }
`;
